/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
import React from 'react';
import moment from 'moment';
import {
  Api,
  ConfirmDialog,
  DateRangeSelectRow,
  downloadBlobAsFile,
  exportToCsv,
  exportToExcel,
  exportToYkbExcel,
  getDisabledStatusForTransactionSlip,
  GetPaymentTransactionsRequestDto,
  getPaymentTransactionStatusEnumForLookup,
  getPaymentTransactionStatusEnumString,
  getSortingQuery,
  PaginationQuery,
  PaymentSourceEnum,
  PaymentSourceEnumLabel,
  PaymentTransaction,
  PaymentTransactionStatusEnum,
  showToast,
  TranslatedMaterialTable,
} from 'core';
import { PaynetCaptureTransactionRequest, PaynetReverseTransactionRequest } from 'apps/paynet';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { UserInfo } from 'apps/auth/models';
import { Filter } from 'material-table';
import { Box, Button, Chip, Grid, IconButton, Menu, MenuItem, MenuList, TextField, Tooltip } from '@material-ui/core';
import { ArrowBack, CheckCircle, Description, DoneAll, Edit, GetApp, Receipt, Send, Undo, Visibility, Warning } from '@material-ui/icons';
import { useHistory } from 'react-router';

const PaymentListPage = () => {
  const [showLoading, setShowLoading] = React.useState(false);
  const [statusFilter, setStatusFilter] = React.useState<PaymentTransactionStatusEnum[]>([]);
  const [selectedPayment, setSelectedPayment] = React.useState<PaymentTransaction | null>(null);
  // Columns state removed; columns are computed via getColumns()
  const [showReverseTransactionDialog, setShowReverseTransactionDialog] = React.useState(false);
  const [showCaptureTransactionDialog, setShowCaptureTransactionDialog] = React.useState(false);
  const [showTransactionDetailDialog, setShowTransactionDetailDialog] = React.useState(false);
  const [showTransactionFilesDialog, setShowTransactionFilesDialog] = React.useState(false);
  const [showAccountingControlConfirmDialog, setShowAccountingControlConfirmDialog] = React.useState(false);
  const [showDeleteFileDialog, setShowDeleteFileDialog] = React.useState(false);
  const [toDeleteFileId, setToDeleteFileId] = React.useState<number>(0);
  const [reLoadTable, setReLoadTable] = React.useState(false);
  const [refundAmount, setRefundAmount] = React.useState<number>(0);
  const [partialRefundAvailable, setPartialRefundAvailable] = React.useState<boolean>(true);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [openSettings, setOpenSettings] = React.useState(false);
  const [focusedData, setFocusedData] = React.useState<any>([]);
  const [showEditTransactionDialog, setShowEditTransactionDialog] = React.useState(false);
  const [editVehiclePlate, setEditVehiclePlate] = React.useState<string>('');
  const [editCardHolder, setEditCardHolder] = React.useState<string>('');
  const [editNotaryBuyerName, setEditNotaryBuyerName] = React.useState<string>('');
  const [editLoading, setEditLoading] = React.useState(false);
  const date = new Date();
  const [selectionRange, setSelectionRange] = React.useState({
    startDate: new Date(date.getFullYear(), date.getMonth(), 1),
    endDate: new Date(date.getFullYear(), date.getMonth() + 1, 0),
    key: 'selection',
  });

  const history = useHistory();
  const dispatch = useDispatch();

  const { userInfo } = useSelector(
    (state: any) => ({
      userInfo: state.auth.userInfo as UserInfo,
    }),
    shallowEqual,
  );

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenSettings(true);
  };

  const getStatusChipStyle = (status: any) => {
    switch (status) {
      case 0: // PRE_AUTH_OR_WAITING_PAYMENT
        return {
          backgroundColor: '#fef3c7',
          color: '#92400e',
          border: '1px solid #fcd34d',
          fontWeight: 600,
        };
      case 1: // COMPLETED
        return {
          backgroundColor: '#d1fae5',
          color: '#065f46',
          border: '1px solid #34d399',
          fontWeight: 600,
        };
      case 2: // TIMEOUT
        return {
          backgroundColor: '#fed7aa',
          color: '#9a3412',
          border: '1px solid #fb923c',
          fontWeight: 600,
        };
      case 3: // FAILED
        return {
          backgroundColor: '#fecaca',
          color: '#991b1b',
          border: '1px solid #f87171',
          fontWeight: 600,
        };
      case 4: // EMPTY
        return {
          backgroundColor: '#f3f4f6',
          color: '#374151',
          border: '1px solid #d1d5db',
          fontWeight: 600,
        };
      case 5: // CANCELLED_OR_RETURNED
        return {
          backgroundColor: '#f1f5f9',
          color: '#475569',
          border: '1px solid #94a3b8',
          fontWeight: 600,
        };
      case 6: // WAITING_APPROVAL_CANCEL_OR_RETURN
        return {
          backgroundColor: '#dbeafe',
          color: '#1e40af',
          border: '1px solid #60a5fa',
          fontWeight: 600,
        };
      case 7: // REJECTED_CANCEL_OR_RETURN
        return {
          backgroundColor: '#fecaca',
          color: '#991b1b',
          border: '1px solid #f87171',
          fontWeight: 600,
        };
      case 8: // PARTIAL_RETURNED_OR_CANCELED
        return {
          backgroundColor: '#ede9fe',
          color: '#7c3aed',
          border: '1px solid #a78bfa',
          fontWeight: 600,
        };
      case 20: // WAITING_TO_SEND_ACCOUNTING_CONTROL
        return {
          backgroundColor: '#fef3c7',
          color: '#92400e',
          border: '1px solid #fcd34d',
          fontWeight: 600,
        };
      case 30: // ACCOUNTING_CONTROL_WAITING
        return {
          backgroundColor: '#dbeafe',
          color: '#1e40af',
          border: '1px solid #60a5fa',
          fontWeight: 600,
        };
      default:
        return {
          backgroundColor: '#f3f4f6',
          color: '#374151',
          border: '1px solid #d1d5db',
          fontWeight: 600,
        };
    }
  };

  const actions: any[] = [
    {
      icon: () => (
        <Button
          variant="contained"
          style={{
            background: 'linear-gradient(45deg, #ff9800 30%, #ffa726 90%)',
            boxShadow: '0 3px 5px 2px rgba(255, 152, 0, .3)',
            color: 'white',
            fontWeight: 600,
            borderRadius: '8px',
            padding: '8px 16px',
            textTransform: 'none',
          }}
        >
          Seçenekler
        </Button>
      ),
      onClick: (event: any, data: any) => {
        setFocusedData(data);
        handleProfileMenuOpen(event);
      },
    },
    /*  (rowData: PaymentTransaction) => ({
      icon: 'download',
      tooltip: 'Dosyaları İndir',
      disabled: !rowData.files || rowData.files.length === 0,
      onClick: (event: any, data: any) => {
        downloadFiles(data);
      },
    }),
    (rowData: PaymentTransaction) => ({
      icon: 'check',
      tooltip: 'Ödemeyi Onayla',
      disabled: rowData.status !== PaymentTransactionStatusEnum.PRE_AUTH_OR_WAITING_PAYMENT,
      onClick: (event: any, data: any) => {
        setSelectedPayment(data as PaymentTransaction);
        setShowCaptureTransactionDialog(true);
      },
    }),
    (rowData: PaymentTransaction) => ({
      icon: 'cancel',
      tooltip: 'Ödemeyi İptal / İade Et',
      disabled: rowData.isRefundable === false,
      onClick: (event: any, data: PaymentTransaction) => {
        setPartialRefundAvailable(
          data.transactionDate !== undefined &&
            new Date(data.transactionDate).toDateString() !== new Date().toDateString(),
        );
        setSelectedPayment(data);
        setRefundAmount(data.refundableAmount);
        setShowReverseTransactionDialog(true);
      },
    }),
    (rowData: PaymentTransaction) => ({
      icon: 'description',
      tooltip: 'Slip Bilgisini Gör',
      disabled: getDisabledStatusForTransactionSlip(rowData.status),
      onClick: (event: any, data: PaymentTransaction) => {
        setSelectedPayment(data);
        getPaymentTransactionSlip(data);
      },
    }), */
  ];

  const getColumns = (): any[] => {
    return [
      {
        title: 'Durum',

        render: (value: any) => {
          const isUnavailable =
            (Number(value.providerType) === Number(PaymentSourceEnum.NKOLAY) ||
              Number(value.providerType) === Number(PaymentSourceEnum.NKOLAY_2) ||
              Number(value.providerType) === Number(PaymentSourceEnum.NKOLAY_3) ||
              Number(value.providerType) === Number(PaymentSourceEnum.IYZICO2)) &&
            Number(value.status) === Number(PaymentTransactionStatusEnum.ACCOUNTING_CONTROL_WAITING) &&
            value.availableForCompleteTransaction !== true;

          const chip = (
            <Chip
              label={getPaymentTransactionStatusEnumString(value.status as PaymentTransactionStatusEnum)}
              icon={isUnavailable ? <Warning style={{ color: '#9b1c1c', fontSize: '16px' }} /> : undefined}
              style={{
                ...getStatusChipStyle(value.status),
                borderRadius: '16px',
                fontSize: '12px',
                height: '28px',
                ...(isUnavailable && {
                  backgroundColor: '#fde8e8',
                  color: '#9b1c1c',
                  border: '1px solid #f8b4b4',
                  fontWeight: 600,
                  opacity: 1,
                }),
              }}
              size="small"
            />
          );

          if (isUnavailable) {
            return (
              <Tooltip title={`Bu işlem tamamlanmaya uygun değildir`} arrow placement="top">
                <span>{chip}</span>
              </Tooltip>
            );
          }

          return chip;
        },
        field: 'status',
        type: 'string',
        cellStyle: { whiteSpace: 'nowrap' },
        sorting: true,
        lookup: getPaymentTransactionStatusEnumForLookup(),
        defaultFilter: statusFilter.map((x) => x.toString()),
        filterPlaceholder: 'Seçiniz',
        searching: false,
      },
      {
        title: 'Sağlayıcı',
        cellStyle: { whiteSpace: 'nowrap' },
        render: (value: any) => PaymentSourceEnumLabel.get(value.providerType),
        field: 'providerType',
        sorting: true,
        filtering: false,
        searching: false,
      },
      {
        title: 'İşlem No',
        cellStyle: { whiteSpace: 'nowrap' },
        field: 'transactionId',
        sorting: true,
        filtering: false,
        searching: false,
      },
      {
        title: 'Referans No',
        cellStyle: { whiteSpace: 'nowrap' },
        field: 'referenceNo',
        sorting: true,
        filtering: false,
        searching: false,
      },
      {
        title: 'Bayi Adı',
        cellStyle: { whiteSpace: 'nowrap' },
        field: 'user.agentName',
        sorting: true,
        searching: false,
        filtering: false,
      },
      {
        title: 'Bayi İl',
        cellStyle: { whiteSpace: 'nowrap' },
        field: 'user.cityName',
        sorting: true,
        searching: false,
        filtering: false,
      },
      {
        title: 'Müşteri Adı',
        field: 'cardHolder',
        cellStyle: { whiteSpace: 'nowrap' },
        filtering: false,
        sorting: true,
        searching: false,
        render: (value: any) => {
          const { cardHolder } = value;
          if (!cardHolder) return '';
          return cardHolder
            .toLocaleLowerCase('tr-TR')
            .split(' ')
            .map((word: string) => word.charAt(0).toLocaleUpperCase('tr-TR') + word.slice(1))
            .join(' ');
        },
      },
      {
        title: 'Plaka',
        field: 'vehiclePlate',
        hidden: true,
        export: true,
        cellStyle: { whiteSpace: 'nowrap' },
        filtering: false,
        sorting: true,
        searching: false,
        render: (value: any) => (value.vehiclePlate ? value.vehiclePlate.toLocaleUpperCase('tr-TR') : ''),
      },
      {
        title: 'Noterdeki Alıcı Adı',
        field: 'notaryBuyerName',
        hidden: true,
        export: true,
        cellStyle: { whiteSpace: 'nowrap' },
        filtering: false,
        sorting: true,
        searching: false,
      },
      {
        title: 'Taksit Sayısı',
        field: 'instalment',
        cellStyle: { whiteSpace: 'nowrap' },
        filtering: false,
        sorting: true,
        searching: false,
      },
      {
        title: 'Brüt Tutar',
        field: 'grossAmount',
        render: (value: any) => (
          <span
            style={{
              fontWeight: 500,
              color: '#059669',
              fontSize: '16px',
            }}
          >
            {(value.grossAmount || 0).toLocaleString('tr-TR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{' '}
            ₺
          </span>
        ),
        cellStyle: { whiteSpace: 'nowrap' },
        filtering: false,
        sorting: true,
        searching: false,
      },
      {
        title: 'Net Tutar',
        field: 'netAmount',
        render: (value: any) => (
          <span
            style={{
              fontWeight: 500,
              color: '#1f2937',
              fontSize: '16px',
            }}
          >
            {(value.netAmount || 0).toLocaleString('tr-TR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{' '}
            ₺
          </span>
        ),
        cellStyle: { whiteSpace: 'nowrap' },
        filtering: false,
        sorting: true,
        searching: false,
      },

      {
        title: 'İşlem Tarihi',
        type: 'date',
        render: (value: any) => (
          <div style={{ fontSize: '16px' }}>
            <div style={{ fontWeight: 500, color: '#1f2937' }}>
              {moment(value.transactionDate).format('DD/MM/YYYY HH:mm')}
            </div>
          </div>
        ),
        field: 'transactionDate',
        cellStyle: { whiteSpace: 'nowrap' },
        filtering: false,
        sorting: true,
        searching: false,
      },
    ];
  };

  const handleDialogClose = () => {
    setShowReverseTransactionDialog(false);
    setShowCaptureTransactionDialog(false);
    setShowTransactionDetailDialog(false);
    setShowTransactionFilesDialog(false);
    setShowAccountingControlConfirmDialog(false);
    setShowEditTransactionDialog(false);
    setToDeleteFileId(0);
    setShowDeleteFileDialog(false);
  };

  const exportPaymentDetailAsPdf = async () => {
    if (!selectedPayment) {
      return;
    }

    const response = await Api.getPaymentDetailAsPdf(selectedPayment?.id);
    if (response) {
      downloadBlobAsFile(response, `odeme-detay${selectedPayment.id}.pdf`);
    } else {
      dispatch(
        showToast({
          message: `Bir sorun oluştu`,
          severity: 'warning',
        }),
      );
    }
  };

  // downloadFiles helper removed (unused)
  const captureTransaction = async () => {
    handleDialogClose();
    setShowLoading(true);
    if (selectedPayment) {
      const request = {
        paymentTransactionId: Number(selectedPayment.id),
        referenceNo: selectedPayment.referenceNo.toString(),
        transactionId: selectedPayment.transactionId?.toString(),
        xactId: selectedPayment.transactionIdHash?.toString(),
      } as PaynetCaptureTransactionRequest;

      const response = await Api.Paynet.captureTransaction(request, selectedPayment.providerType);
      if (response.isSuccess) {
        setReLoadTable(true);
        dispatch(
          showToast({
            message: `Ödeme onaylama işlemi başarılı!`,
          }),
        );
      } else {
        dispatch(
          showToast({
            message: `${response.errorMessage ?? 'lütfen daha sonra tekrar deneyiniz!'}`,
            severity: 'error',
          }),
        );
      }
    }
    setShowCaptureTransactionDialog(false);
    setShowLoading(false);
    setSelectedPayment(null);
    setReLoadTable(false);
  };

  const onBlurRefundAmount = (event: any) => {
    const amount = event.target.value;
    setRefundAmount(Number(amount));
  };

  const validateRefundAmount = (): boolean => {
    if (!selectedPayment) {
      return false;
    }

    // kısmi iade yapılamıyorsa, true olarak dön. Çünkü tüm tutar iade olacak
    if (!partialRefundAvailable) {
      return true;
    }

    let message = null;
    if (refundAmount < 1) {
      message = `İade/iptal edeceğiniz tutar 1 TL'den büyük olmalıdır.`;
    }

    if (refundAmount > selectedPayment.refundableAmount) {
      message = `İade/iptal edebileceğiniz maksimum tutar: ${selectedPayment.refundableAmount.toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ₺`;
    }

    if (selectedPayment.refundableAmount - refundAmount <= 1 && selectedPayment.refundableAmount - refundAmount !== 0) {
      message = `Lütfen daha yüksek iade/iptal tutarı giriniz.
                  (Girdiğiniz tutar ile birlikte kalan tutar 1 TL'den büyük olmalı)`;
    }

    if (message) {
      dispatch(
        showToast({
          message,
          severity: 'error',
        }),
      );
      return false;
    }

    return true;
  };

  const reverseTransaction = async () => {
    if (selectedPayment) {
      if (!validateRefundAmount()) {
        return;
      }

      handleDialogClose();
      setShowLoading(true);

      const request = {
        paymentTransactionId: Number(selectedPayment.id),
        xactId: selectedPayment.transactionIdHash?.toString(),
        amount: refundAmount,
      } as PaynetReverseTransactionRequest;

      const response = await Api.Paynet.reverseTransaction(request, selectedPayment.providerType);
      if (response.isSuccess) {
        setReLoadTable(true);
        dispatch(
          showToast({
            message: `İptal/İade talebi başarıyla oluşturuldu!`,
          }),
        );
      } else {
        dispatch(
          showToast({
            message: `Bir hata oluştu. ${response.errorMessage ?? 'lütfen daha sonra tekrar deneyiniz!'}`,
            severity: 'error',
          }),
        );
      }
    }
    setShowReverseTransactionDialog(false);
    setShowLoading(false);
    setSelectedPayment(null);
    setReLoadTable(false);
  };

  const getPaymentTransactions = async (query: any) => {
    const { filters, orderBy, orderDirection, page, pageSize, search } = query;
    try {
      setShowLoading(true);
      const statusFilterLocal = filters
        .find((x: Filter<any>) => x.column.field == 'status')
        ?.value.map((val: string) => Number(val) as PaymentTransactionStatusEnum);
      setStatusFilter(statusFilterLocal);

      const requestDto = {
        paginationQuery: { page, pageSize } as PaginationQuery,
        providerType: PaymentSourceEnum.IYZICO,
        sortingQuery: getSortingQuery(orderBy, orderDirection),
        statuses: statusFilterLocal,
        searchText: search,
        endDate: moment(selectionRange.endDate).local().toDate(),
        startDate: moment(selectionRange.startDate).local().toDate(),
      } as GetPaymentTransactionsRequestDto;

      const response = await Api.getPaymentTransactions(requestDto);
      if (response.isSuccess) {
        const { result } = response;
        return {
          data: result?.data ?? [],
          page,
          totalCount: result?.totalCount ?? 0,
        };
      }
      dispatch(
        showToast({
          message: `Bir hata oluştu. ${response.errorMessage ?? 'lütfen daha sonra tekrar deneyiniz!'}`,
          severity: 'error',
        }),
      );
    } catch (e: any) {
      dispatch(
        showToast({
          message: `Bir hata oluştu. ${e.message ?? 'lütfen daha sonra tekrar deneyiniz!'}`,
          severity: 'error',
        }),
      );
    } finally {
      setShowLoading(false);
    }

    return {
      data: [],
      page: 0,
      totalCount: 0,
    };
  };

  const getAllPaymentTransactions = async (
    ignoreDateRange = false,
    statuses?: PaymentTransactionStatusEnum[],
  ) => {
    setShowLoading(true);
    try {
      const requestDto: GetPaymentTransactionsRequestDto = {
        providerType: PaymentSourceEnum.IYZICO,
        statuses,
        ...(ignoreDateRange
          ? {}
          : {
              endDate: moment(selectionRange.endDate).local().toDate(),
              startDate: moment(selectionRange.startDate).local().toDate(),
            }),
      };

      const response = await Api.getTransactionsWithoutPagination(requestDto);
      if (response.isSuccess) {
        return response.result;
      }
      dispatch(
        showToast({
          message: `Ödeme listesi çekilirken bir hata oluştu. ${response.errorMessage}`,
          severity: 'error',
        }),
      );
    } catch (e: any) {
      dispatch(
        showToast({
          message: `Ödeme listesi çekilirken bir hata oluştu. ${e.message}`,
          severity: 'error',
        }),
      );
    } finally {
      setShowLoading(false);
    }
    return null;
  };

  const getPaymentTransactionSlip = async (paymentTransaction: PaymentTransaction) => {
    if (paymentTransaction) {
      setShowLoading(true);

      const response = await Api.getPaymentTransactionSlip(paymentTransaction.id);
      if (response.isSuccess) {
        const newWindow = window.open(response.result?.url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
      } else {
        dispatch(
          showToast({
            message: `Bir hata oluştu. ${response.errorMessage ?? 'lütfen daha sonra tekrar deneyiniz!'}`,
            severity: 'error',
          }),
        );
      }
    }
    setShowLoading(false);
    setSelectedPayment(null);
  };

  const sendToAccountingControlWaitingStatus = async (paymentTransaction: PaymentTransaction) => {
    if (!paymentTransaction) {
      return;
    }

    setShowLoading(true);

    const response = await Api.Paynet.sendToAccountingControlWaitingStatus(paymentTransaction.id);
    if (!response.isSuccess) {
      dispatch(
        showToast({
          message: `Bir hata oluştu. ${response.errorMessage ?? 'lütfen daha sonra tekrar deneyiniz!'}`,
          severity: 'error',
        }),
      );
    } else {
      setReLoadTable(true);
    }

    setShowLoading(false);
    setSelectedPayment(null);
    setReLoadTable(false);
    setOpenSettings(false);
  };

  const sendToCompletedStatus = async (paymentTransaction: PaymentTransaction) => {
    if (!paymentTransaction) {
      return;
    }

    setShowLoading(true);

    const response = await Api.Paynet.sendToCompletedStatus(paymentTransaction.id);
    if (!response.isSuccess) {
      dispatch(
        showToast({
          message: `Bir hata oluştu. ${response.errorMessage ?? 'lütfen daha sonra tekrar deneyiniz!'}`,
          severity: 'error',
        }),
      );
    } else {
      setReLoadTable(true);
    }

    setShowLoading(false);
    setSelectedPayment(null);
    setReLoadTable(false);
    setOpenSettings(false);
  };

  const exportToExcelAllData = async (columns: any) => {
    const allPaymentTransactions = await getAllPaymentTransactions();
    if (!allPaymentTransactions) return;

    exportToExcel(columns, allPaymentTransactions);
  };

  const exportPendingTransfersToExcel = async () => {
    setShowLoading(true);
    try {
      const allTransactions = await getAllPaymentTransactions(true, [
        PaymentTransactionStatusEnum.ACCOUNTING_CONTROL_WAITING,
      ]);
      if (!allTransactions || !Array.isArray(allTransactions)) return;

      const pendingTransactions = allTransactions.filter(
        (t: any) =>
          t.availableForCompleteTransaction === true &&
          Number(t.status) === Number(PaymentTransactionStatusEnum.ACCOUNTING_CONTROL_WAITING),
      );

      if (pendingTransactions.length === 0) {
        dispatch(
          showToast({
            message: 'Para transferi bekleyen işlem bulunamadı.',
            severity: 'info',
          }),
        );
        return;
      }

      exportToYkbExcel(pendingTransactions);
    } catch (e: any) {
      dispatch(
        showToast({
          message: `Excel indirilirken hata oluştu: ${e.message}`,
          severity: 'error',
        }),
      );
    } finally {
      setShowLoading(false);
    }
  };

  const onDateRangeSelected = (event: any) => {
    setSelectionRange(event);

    setReLoadTable(true);
    setReLoadTable(false);
  };

  const handleUpdatePaymentTransaction = async () => {
    if (!selectedPayment) return;
    if (!editVehiclePlate.trim() || !editCardHolder.trim()) {
      dispatch(
        showToast({
          message: 'Plaka ve Kart Sahibi alanları boş bırakılamaz!',
          severity: 'warning',
        }),
      );
      return;
    }
    setEditLoading(true);
    try {
      const response = await Api.updatePaymentTransaction({
        paymentTransactionId: selectedPayment.id,
        vehiclePlate: editVehiclePlate.trim(),
        cardHolder: editCardHolder.trim(),
        notaryBuyerName: editNotaryBuyerName.trim(),
      });
      if (response.isSuccess) {
        dispatch(
          showToast({
            message: 'Plaka / Kart sahibi bilgisi başarıyla güncellendi!',
          }),
        );
        setReLoadTable(true);
      } else {
        dispatch(
          showToast({
            message: `Bir hata oluştu. ${response.errorMessage ?? 'lütfen daha sonra tekrar deneyiniz!'}`,
            severity: 'error',
          }),
        );
      }
    } catch (e: any) {
      dispatch(
        showToast({
          message: `Bir hata oluştu. ${e.message ?? 'lütfen daha sonra tekrar deneyiniz!'}`,
          severity: 'error',
        }),
      );
    } finally {
      setEditLoading(false);
      setShowEditTransactionDialog(false);
      setSelectedPayment(null);
      setReLoadTable(false);
      setOpenSettings(false);
    }
  };

  const handleDeleteFile = async (fileId: number) => {
    setShowLoading(true);

    const response = await Api.deleteFile(fileId);
    setShowLoading(false);

    if (response.isSuccess) {
      selectedPayment!.files = selectedPayment!.files?.filter((x) => x.id !== fileId);
      dispatch(
        showToast({
          message: 'Dosya başarıyla silindi.',
          severity: 'success',
        }),
      );
    } else {
      dispatch(
        showToast({
          message: `Dosya silinirken bir hata oluştu. ${response.errorMessage}`,
          severity: 'error',
        }),
      );
    }

    setToDeleteFileId(0);
    setShowDeleteFileDialog(false);
  };

  return (
    <React.Fragment>
      <Menu
        anchorEl={anchorEl}
        open={openSettings}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={() => setOpenSettings(false)}
        PaperProps={{
          style: {
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            border: '1px solid rgba(0, 0, 0, 0.05)',
            minWidth: '220px',
          },
        }}
      >
        <MenuList style={{ padding: '8px 0' }}>
          <MenuItem
            disabled={!focusedData.files || focusedData.files.length === 0}
            onClick={() => {
              setSelectedPayment(focusedData as PaymentTransaction);
              setShowTransactionFilesDialog(true);
            }}
            style={{
              padding: '12px 16px',
              margin: '2px 8px',
              borderRadius: '8px',
              transition: 'all 0.2s ease',
            }}
          >
            <Visibility style={{ color: '#059669', marginRight: 12 }} />
            <span style={{ fontSize: '14px', fontWeight: 500 }}>Dosyaları Görüntüle</span>
          </MenuItem>
          <MenuItem
            disabled={focusedData.status !== PaymentTransactionStatusEnum.PRE_AUTH_OR_WAITING_PAYMENT}
            onClick={() => {
              setSelectedPayment(focusedData as PaymentTransaction);
              setShowCaptureTransactionDialog(true);
            }}
            style={{
              padding: '12px 16px',
              margin: '2px 8px',
              borderRadius: '8px',
              transition: 'all 0.2s ease',
            }}
          >
            <CheckCircle style={{ color: '#059669', marginRight: 12 }} />
            <span style={{ fontSize: '14px', fontWeight: 500 }}>Ödemeyi Onayla</span>
          </MenuItem>
          <MenuItem
            disabled={focusedData.isRefundable === false || !userInfo.isAdmin}
            onClick={() => {
              setPartialRefundAvailable(
                focusedData.transactionDate !== undefined &&
                  new Date(focusedData.transactionDate).toDateString() !== new Date().toDateString(),
              );
              setSelectedPayment(focusedData);
              setRefundAmount(focusedData.refundableAmount);
              setShowReverseTransactionDialog(true);
            }}
            style={{
              padding: '12px 16px',
              margin: '2px 8px',
              borderRadius: '8px',
              transition: 'all 0.2s ease',
              opacity: !userInfo.isAdmin || focusedData.isRefundable === false ? 0.5 : 1,
            }}
          >
            <Undo style={{ color: '#dc2626', marginRight: 12 }} />
            <span style={{ fontSize: '14px', fontWeight: 500 }}>Ödemeyi İptal / İade Et</span>
            {!userInfo.isAdmin && (
              <span style={{ fontSize: '12px', color: '#999', marginLeft: '8px' }}>(Admin Only)</span>
            )}
          </MenuItem>
          <MenuItem
            disabled={
              (focusedData.providerType != PaymentSourceEnum.NKOLAY &&
                focusedData.providerType != PaymentSourceEnum.NKOLAY_2 &&
                focusedData.providerType != PaymentSourceEnum.NKOLAY_3 &&
                focusedData.providerType != PaymentSourceEnum.IYZICO2) ||
              focusedData.status !== PaymentTransactionStatusEnum.WAITING_TO_SEND_ACCOUNTING_CONTROL
            }
            onClick={() => {
              setSelectedPayment(focusedData);
              setShowAccountingControlConfirmDialog(true);
              setOpenSettings(false);
            }}
            style={{
              padding: '12px 16px',
              margin: '2px 8px',
              borderRadius: '8px',
              transition: 'all 0.2s ease',
            }}
          >
            <Send style={{ color: '#1e40af', marginRight: 12 }} />
            <span style={{ fontSize: '14px', fontWeight: 500 }}>Muhasebe Kontrolüne Gönder</span>
          </MenuItem>
          <MenuItem
            disabled={
              (focusedData.providerType != PaymentSourceEnum.NKOLAY &&
                focusedData.providerType != PaymentSourceEnum.NKOLAY_2 &&
                focusedData.providerType != PaymentSourceEnum.NKOLAY_3 &&
                focusedData.providerType != PaymentSourceEnum.IYZICO2) ||
              focusedData.status !== PaymentTransactionStatusEnum.ACCOUNTING_CONTROL_WAITING ||
              focusedData.availableForCompleteTransaction != true
            }
            onClick={() => {
              setSelectedPayment(focusedData);
              sendToCompletedStatus(focusedData);
            }}
            style={{
              padding: '12px 16px',
              margin: '2px 8px',
              borderRadius: '8px',
              transition: 'all 0.2s ease',
            }}
          >
            <DoneAll style={{ color: '#059669', marginRight: 12 }} />
            <span style={{ fontSize: '14px', fontWeight: 500 }}>Para Transferi Tamamlandı</span>
          </MenuItem>
          <MenuItem
            disabled={
              focusedData.providerType != PaymentSourceEnum.NKOLAY &&
              focusedData.providerType != PaymentSourceEnum.NKOLAY_2 &&
              focusedData.providerType != PaymentSourceEnum.NKOLAY_3 &&
              focusedData.providerType != PaymentSourceEnum.IYZICO2
            }
            onClick={() => {
              setSelectedPayment(focusedData);
              setShowTransactionDetailDialog(true);
            }}
            style={{
              padding: '12px 16px',
              margin: '2px 8px',
              borderRadius: '8px',
              transition: 'all 0.2s ease',
            }}
          >
            <Receipt style={{ color: '#7c3aed', marginRight: 12 }} />
            <span style={{ fontSize: '14px', fontWeight: 500 }}>Ödeme Detay</span>
          </MenuItem>
          <MenuItem
            hidden={focusedData.providerType != PaymentSourceEnum.IYZICO}
            disabled={getDisabledStatusForTransactionSlip(focusedData.status)}
            onClick={() => {
              setSelectedPayment(focusedData);
              getPaymentTransactionSlip(focusedData);
            }}
            style={{
              padding: '12px 16px',
              margin: '2px 8px',
              borderRadius: '8px',
              transition: 'all 0.2s ease',
            }}
          >
            <Description style={{ color: '#f59e0b', marginRight: 12 }} />
            <span style={{ fontSize: '14px', fontWeight: 500 }}>Slip Bilgisini Gör</span>
          </MenuItem>
          <MenuItem
            disabled={!userInfo.isAdmin}
            onClick={() => {
              setSelectedPayment(focusedData as PaymentTransaction);
              setEditVehiclePlate(focusedData.vehiclePlate ?? '');
              setEditCardHolder(focusedData.cardHolder ?? '');
              setEditNotaryBuyerName(focusedData.notaryBuyerName ?? '');
              setShowEditTransactionDialog(true);
              setOpenSettings(false);
            }}
            style={{
              padding: '12px 16px',
              margin: '2px 8px',
              borderRadius: '8px',
              transition: 'all 0.2s ease',
              opacity: !userInfo.isAdmin ? 0.5 : 1,
            }}
          >
            <Edit style={{ color: '#2563eb', marginRight: 12 }} />
            <span style={{ fontSize: '14px', fontWeight: 500 }}>Plaka / Kart Sahibi Düzenle</span>
          </MenuItem>
        </MenuList>
      </Menu>
      <div
        style={{
          padding: '16px 24px',
          paddingTop: '80px',
          backgroundColor: '#fafafa',
          minHeight: '100vh',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '24px',
            backgroundColor: 'white',
            padding: '16px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
          }}
        >
          <IconButton
            onClick={() => history.goBack()}
            style={{
              backgroundColor: '#f3f4f6',
              marginRight: '16px',
              borderRadius: '8px',
            }}
          >
            <ArrowBack />
          </IconButton>
          <h2
            style={{
              margin: 0,
              fontSize: '24px',
              fontWeight: 600,
              color: '#1f2937',
              flex: 1,
            }}
          >
            Ödeme Listesi
          </h2>
          {(userInfo?.isAdmin || userInfo?.isAccounting) && (
            <Button
              variant="contained"
              onClick={exportPendingTransfersToExcel}
              startIcon={<GetApp />}
              style={{
                backgroundColor: '#2563eb',
                color: 'white',
                fontWeight: 600,
                borderRadius: '8px',
                textTransform: 'none',
                padding: '8px 16px',
                boxShadow: '0 2px 4px rgba(37, 99, 235, 0.2)',
              }}
            >
              Para Transferi Bekleyenleri İndir (YKB Excel)
            </Button>
          )}
        </div>

        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
            marginBottom: '20px',
          }}
        >
          <DateRangeSelectRow selectionRange={selectionRange} onSelectionRange={onDateRangeSelected} />
        </div>

        {!reLoadTable && (
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
              overflow: 'hidden',
            }}
          >
            <TranslatedMaterialTable
              title=""
              columns={getColumns()}
              data={getPaymentTransactions}
              actions={actions}
              isLoading={showLoading}
              options={{
                filtering: true,
                pageSize: 100,
                exportAllData: true,
                exportButton: { csv: true, pdf: false },
                exportCsv: exportToExcelAllData,
                headerStyle: {
                  backgroundColor: '#f8fafc',
                  color: '#374151',
                  fontWeight: 600,
                  fontSize: '14px',
                  padding: '16px 12px',
                  borderBottom: '2px solid #e5e7eb',
                },
                rowStyle: (rowData: any, index: number) => ({
                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafafa',
                  '&:hover': {
                    backgroundColor: '#f0f9ff !important',
                  },
                }),
                // 'cellStyle' is not a valid option for MaterialTable's options prop.
                // To style cells, use columns' 'cellStyle' property instead.
              }}
            />
          </div>
        )}
      </div>
      <ConfirmDialog
        title="Ödeme İptal/İade"
        open={showReverseTransactionDialog}
        // eslint-disable-next-line no-lone-blocks
        handleConfirm={reverseTransaction}
        handleClose={handleDialogClose}
      >
        {selectedPayment && partialRefundAvailable && (
          <div>
            <b>{selectedPayment?.transactionId}</b> numaralı işlem için iptal/iade etmek istediğiniz tutarı giriniz.{' '}
            <b>
              (Maks.{' '}
              {selectedPayment.refundableAmount.toLocaleString('tr-TR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{' '}
              ₺)
            </b>
            <br />
          </div>
        )}

        {selectedPayment && !partialRefundAvailable && (
          <div>
            <b>{selectedPayment?.transactionId}</b> numaralı işlemin tüm tutarı iade/iptal olacak. Ödemenin alındığı gün
            kısmi iade yapılamaz ve bütün tutar iade/iptal olur.
            <br />
          </div>
        )}

        {selectedPayment && (
          <TextField
            autoFocus
            margin="dense"
            id="refundableAmount"
            label="Tutar"
            type="number"
            disabled={!partialRefundAvailable}
            defaultValue={refundAmount}
            onBlur={onBlurRefundAmount}
          />
        )}
      </ConfirmDialog>
      <ConfirmDialog
        title="Ödemeyi Onayla"
        open={showCaptureTransactionDialog}
        // eslint-disable-next-line no-lone-blocks
        handleConfirm={captureTransaction}
        handleClose={handleDialogClose}
      >
        {selectedPayment && `${selectedPayment?.transactionId} numaralı işlemi onaylamak istediğinize emin misiniz?`}
      </ConfirmDialog>

      <ConfirmDialog
        title="Ödeme Detayı"
        confirmText="PDF Formatında İndir"
        cancelText="Kapat"
        open={showTransactionDetailDialog}
        // eslint-disable-next-line no-lone-blocks
        handleClose={handleDialogClose}
        handleConfirm={exportPaymentDetailAsPdf}
      >
        {selectedPayment && (
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={6} md={6}>
                Satıcı İsmi (Ticari Ünvan)
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedPayment.user.companyName ?? selectedPayment.user.agentName}
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                Satıcı Mail
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedPayment.user.email}
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                Alıcı İsim
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedPayment.cardHolder}
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                Aracın Plaka Bilgisi
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedPayment.vehiclePlate}
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                Banka Bilgisi
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedPayment.bankName}
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                Taksit Sayısı
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedPayment.instalment}
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                Net Tutar
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedPayment.netAmount?.toLocaleString('tr-TR')} ₺
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                Brüt Tutar
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedPayment.grossAmount?.toLocaleString('tr-TR')} ₺
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                Satıcı Iban
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedPayment.user.iban}
              </Grid>
            </Grid>
          </Box>
        )}
      </ConfirmDialog>

      <ConfirmDialog
        title="Yüklenen Dosyalar"
        confirmText=""
        cancelText="Kapat"
        open={showTransactionFilesDialog}
        // eslint-disable-next-line no-lone-blocks
        handleClose={handleDialogClose}
        handleConfirm={handleDialogClose}
      >
        {selectedPayment && (
          <Box>
            <Grid container spacing={2}>
              {selectedPayment.files
                .filter((x) => x.url.endsWith('pdf'))
                .map((item) => (
                  <Grid key={`img-${item.id}`} item xs={6} sm={6} md={6}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <a href={item.url} target="_blank" rel="noreferrer">
                        <img src="/pdf1.png" alt="" style={{ width: '100%', height: 200 }} />
                      </a>
                      <Button
                        variant="contained"
                        style={{
                          marginTop: 8,
                          width: '80%',
                          backgroundColor: '#dc2626',
                          color: '#fff',
                        }}
                        onClick={() => {
                          setShowDeleteFileDialog(true);
                          setToDeleteFileId(item.id);
                        }}
                      >
                        Sil
                      </Button>
                    </div>
                  </Grid>
                ))}
              {selectedPayment.files
                .filter((x) => !x.url.endsWith('pdf'))
                .map((item) => (
                  <Grid key={`img-${item.id}`} item xs={6} sm={6} md={6}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <a href={item.url} target="_blank" rel="noreferrer">
                        <img src={item.url} alt="" style={{ width: '100%', height: 200 }} />
                      </a>
                      <Button
                        variant="contained"
                        style={{
                          marginTop: 8,
                          width: '80%',
                          backgroundColor: '#dc2626',
                          color: '#fff',
                        }}
                        onClick={() => {
                          setShowDeleteFileDialog(true);
                          setToDeleteFileId(item.id);
                        }}
                      >
                        Sil
                      </Button>
                    </div>
                  </Grid>
                ))}
            </Grid>
          </Box>
        )}
      </ConfirmDialog>

      <ConfirmDialog
        title="Muhasebe Kontrolüne Gönder"
        confirmText="Onay"
        cancelText="İptal"
        open={showAccountingControlConfirmDialog}
        handleConfirm={() => {
          if (selectedPayment) {
            sendToAccountingControlWaitingStatus(selectedPayment);
          }
          handleDialogClose();
        }}
        handleClose={handleDialogClose}
      >
        {selectedPayment &&
          `${selectedPayment?.transactionId} numaralı işlem muhasebe kontrolüne gönderilecektir. Onaylıyor musunuz?`}
      </ConfirmDialog>

      <ConfirmDialog
        title="Dosya Silme Onayı"
        confirmText="Onay"
        cancelText="İptal"
        open={showDeleteFileDialog}
        handleConfirm={() => {
          if (toDeleteFileId) {
            handleDeleteFile(toDeleteFileId);
          }
        }}
        handleClose={() => {
          setToDeleteFileId(0);
          setShowDeleteFileDialog(false);
        }}
      >
        {selectedPayment &&
          `${selectedPayment?.transactionId} numaralı işlemden dosya silinecektir. Onaylıyor musunuz?`}
      </ConfirmDialog>

      <ConfirmDialog
        title="Plaka / Kart Sahibi Düzenle"
        confirmText="Güncelle"
        cancelText="İptal"
        open={showEditTransactionDialog}
        handleConfirm={handleUpdatePaymentTransaction}
        handleClose={handleDialogClose}
        showLoading={editLoading}
      >
        {selectedPayment && (
          <Box>
            <TextField
              autoFocus
              margin="dense"
              label="Araç Plakası"
              type="text"
              fullWidth
              value={editVehiclePlate}
              onChange={(e) => setEditVehiclePlate(e.target.value)}
              style={{ marginBottom: 16 }}
            />
            <TextField
              margin="dense"
              label="Kart Sahibi"
              type="text"
              fullWidth
              value={editCardHolder}
              onChange={(e) => setEditCardHolder(e.target.value)}
              style={{ marginBottom: 16 }}
            />
            <TextField
              margin="dense"
              label="Noterdeki Alıcı Adı"
              type="text"
              fullWidth
              value={editNotaryBuyerName}
              onChange={(e) => setEditNotaryBuyerName(e.target.value)}
            />
          </Box>
        )}
      </ConfirmDialog>
    </React.Fragment>
  );
};

export default PaymentListPage;
